import {isDateFuture, getInPercent} from '@/helpers';
import i18n from '@/i18n';
import DEFINES from '@/defines';

const getSeatsStatus = {
  methods: {
    getSeatsStatus (screener) {
      if (!screener) {
        return;
      }

      // Registration ended
      if (!isDateFuture (screener.registration_ends_at)) {
        return i18n.t ('screener.seats_availability_status', {
          class: 'error',
          status: "<b>"+i18n.t ('screener.seats_status.no_seats')+" ("+i18n.t('screener.btn.reg_closed')+")</b>",
        });
      }

      // Screening ended
      if (!isDateFuture (screener.screening_ends_at)) {
        return i18n.t ('screener.seats_availability_status', {
          class: 'error',
          status: i18n.t ('screener.seats_status.no_seats'),
        });
      }

      let used_seats = screener.num_of_enrollments;
      let total_seats = screener.limitation;

      let occupied_percent = getInPercent (used_seats, total_seats);

      // 100% occupied
      if (occupied_percent == 100) {
        return i18n.t ('screener.seats_availability_status', {
          class: 'error',
          status: i18n.t ('screener.seats_status.no_seats'),
        });
      }

      // Below 100% but above 75%
      if (DEFINES.SCREENER_OCCUPIED_SEATS_PERCENTAGE <= occupied_percent) {
        return i18n.t ('screener.seats_availability_status', {
          class: 'success',
          status: i18n.t ('screener.seats_status.seats_left', {
            seats: total_seats - used_seats,
          }),
        });
      }

      // Below 75%
      return i18n.t ('screener.seats_availability_status', {
        class: 'success',
        status: i18n.t ('screener.seats_status.available'),
      });
    },
  },
};

export {getSeatsStatus};
